export default function truncate(text, stop, clamp = "...") {
  if (!text) return ""; // Handle null/undefined/empty text

  return text.length > stop ? text.slice(0, stop) + clamp : text; // Return the original text if it's within the limit
}
